package empiresmp.feature.gallery.presentation

import empiresmp.feature.gallery.data.GalleryRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.launch
import ru.astrainteractive.klibs.paging.collector.IntPagerCollector
import ru.astrainteractive.klibs.paging.util.loadNextPage

internal class GalleryViewModel(
    private val galleryRepository: GalleryRepository
) {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)

    val paging = IntPagerCollector(
        initialPage = 0,
        pager = {
            runCatching {
                galleryRepository
                    .getGalleryItems(it.pageContext.page)
                    .data
            }
        }
    )

    fun dispose() {
        scope.cancel()
    }
    fun loadNextPage() {
        scope.launch { paging.loadNextPage() }
    }
    init {
        scope.launch { paging.loadNextPage() }
    }
}
